export const APP_IDS: Record<string, Record<string, string>> = {
  development: {
    web_cp: "rUuJTY0RW1",
  },
  uat: {
    web_cp: "MYR5PYG0iR",
  },
  production: {
    web_cp: "HhLJObxsx2",
  },
};
